import { Injectable } from '@angular/core';
import { GetUserGQL } from '../../../../graphql/generated';
import { UserModel } from '../../../shared/models/user.model';
import { GetUserMapper } from '../../../shared/mappers/user.mapper';
import { GraphqlService } from '../../../shared/services/graphql.service';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor(
    private getUser: GetUserGQL,
    private graphqlService: GraphqlService
  ) {}

  async getUserAndRole(): Promise<UserModel> {
    return this.graphqlService.fetch<UserModel>(
      this.getUser,
      {},
      new GetUserMapper()
    );
  }
}
